import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { FlexCenter } from '../../../../global/commonStyle';

interface Props {
  isTeamMember?: boolean;
}

const Main = styled.div<Props>`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  padding: var(--space-11);
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  ${({ isTeamMember }) =>
    isTeamMember &&
    css`
      ${mobile_xl(css`
        grid-column: 1 / span 2;
      `)}
    `}
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const Title = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const Count = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;
const Total = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: var(--space-16);
  ${mobile_xl(css`
    grid-template-columns: repeat(2, 1fr);
  `)}
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    margin-block: var(--space-8) var(--space-80);
  `)}
`;

const Storage = styled.div`
  width: 100%;
  max-width: 622px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  padding: var(--space-20);
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  display: flex;
  gap: var(--space-24);
  align-items: center;
  ${mobile_xl(css`
    width: auto;
  `)}
`;
const Left = styled.div`
  position: relative;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;
const Heading = styled.h1`
  margin: var(--space-0);
  ${Typography.heading_lg}
  color: var(--text-primary);
  ${mobile_xl(css`
    ${Typography.body_xl_medium}
  `)}
`;

const Topline = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .stroke-color {
    path {
      stroke: var(--text-secondary);
    }
  }
`;

const CircleProgress = styled.svg`
  transform: rotate(90deg); /* Rotates progress to start from bottom */

  .progress-trail {
    fill: none;
    stroke: var(--neutral-secondary); /* Background color of the progress circle */
    stroke-width: 20;
  }

  .progress-bar {
    fill: none;
    stroke: var(--brand-primary); /* Active progress color */
    stroke-width: 20;
    stroke-linecap: butt;
    transition: stroke-dashoffset var(--transition-extra-slow) ease-in-out;
  }
  ${mobile_xl(css`
    width: 120px;
    height: 120px;
  `)}
`;
const ProgressText = styled.text`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  position: absolute;
  top: 50%;
  width: max-content;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    svg {
      width: 18px;
      height: 18px;
    }
  `)}
`;

export {
  Main,
  Title,
  Count,
  Total,
  Content,
  Storage,
  Left,
  Right,
  Heading,
  Topline,
  CircleProgress,
  ProgressText,
  Icon
};
